/* eslint-disable react/destructuring-assignment */
import React from 'react';
import {
  Button, Modal, ModalBody, ModalFooter,
} from 'reactstrap';

const ModalCommon = (props: any) => (
  <>
    <Modal isOpen={props.isOpen}>
      {/* <ModalHeader></ModalHeader> */}
      <ModalBody>
        {props.message}
      </ModalBody>
      <ModalFooter>
        <Button color="primary" onClick={props.handleCloseModal}>閉じる</Button>
      </ModalFooter>
    </Modal>
  </>
);

export default ModalCommon;
